import "./menu.scss"

export default function Menu({menuOpen, setMenuOpen}){
    return (
        <div className={"menu "+(menuOpen && "active")}>
            <ul>
                <li onClick={()=>{setMenuOpen(false)}}>
                    <a href={"#home"}>Accueil</a>
                </li>
                <li onClick={()=>{setMenuOpen(false)}}>
                    <a href={"#intro"}>A propos</a>
                </li>
                <li onClick={()=>{setMenuOpen(false)}}>
                    <a href={"#portfolio"}>Mes projets</a>
                </li>
                <li onClick={()=>{setMenuOpen(false)}}>
                    <a href={"#contact"}>Contact</a>
                </li>
                <li onClick={()=>{setMenuOpen(false)}}>
                    <a href={"#resume"}>CV</a>
                </li>
            </ul>
        </div>
    )
}